import { mergeDeepRight } from 'ramda';
import countriesRaw from 'config/data/countries.json';
import { initialState, loadingReducer, successReducer, errorReducer } from 'store/common';
import { createReducer, getErrorActionName, getSuccessActionName } from 'store/utils';

import { COUNTRIES } from './actions';

// Populate the intial state with countries from the json file
const initialCountriesState = mergeDeepRight(initialState, {
  data: {
    entities: {
      countries: countriesRaw,
    },
  },
});

export default createReducer(
  {
    [COUNTRIES]: loadingReducer,
    [getSuccessActionName(COUNTRIES)]: successReducer,
    [getErrorActionName(COUNTRIES)]: errorReducer,
  },
  initialCountriesState
);
